import React, { createContext, useContext, useState } from 'react';
import { DishSheet } from '@/components/DishSheet';

interface DishSheetContextType {
  openDishSheet: (dishId: string) => void;
}

const DishSheetContext = createContext<DishSheetContextType>({
  openDishSheet: () => {},
});

export const useDishSheet = () => useContext(DishSheetContext);

export const DishSheetProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [dishId, setDishId] = useState<string | null>(null);

  return (
    <DishSheetContext.Provider value={{ openDishSheet: setDishId }}>
      {children}
      <DishSheet dishId={dishId} onClose={() => setDishId(null)} />
    </DishSheetContext.Provider>
  );
};
